<template>
  <overview-table
    title="Ingressos (Venda POS)"
    :headers="headers"
    :items="items"
    :footers="footers"
  >
    <template #[`item.type`]="{ item }">
      <span>{{ item.sector_name }} ({{ item.ticket_type_name }})</span>
    </template>
    <template #[`item.price`]="{ item }">
      <span>{{ currency(parseFloat(item.price)) }}</span>
    </template>
    <template #no-data>
      <h4>Ainda não existem ingressos vendidos nos pontos de venda deste evento.</h4>
    </template>
  </overview-table>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import type Overview from '@/types/Overview'
import type { OverviewSummaryItem } from '@/types/Overview'
import { currency } from '@/helpers/formatters/currency'
import { FreeTypes } from '@/constants/TicketTypeNames'
import OverviewTable from './partials/OverviewTable.vue'

const { overview } = defineProps<{ overview: Overview }>()

// --- Items ---
const items = computed(() => {
  const filtered = overview.summary.filter(item => item.origin != 'venda_online' && !FreeTypes.includes(item.ticket_type_name))

  // The table displays the tickets without the POSs names, so we need to group them
  const groups: Record<string, OverviewSummaryItem> = {}
  filtered.forEach((item) => {
    const key = `${item.ticket_type_id}#${item.batch}`

    if (key in groups) {
      groups[key].generated += item.generated
      groups[key].read += item.read
    } else {
      groups[key] = { ...item }
    }
  })

  return Object.values(groups)
})

// --- Header ---
const _headers = ref([
  { key: 'type', value: 'type', title: 'Tipo', sortable: false },
  { key: 'batch', value: 'batch', title: 'Lote', sortable: true },
  { key: 'price', value: 'price', title: 'Valor Unitário', sortable: true },
  { key: 'generated', value: 'generated', title: 'Vendidos', sortable: true },
  { key: 'printed', value: 'printed', title: 'Impressos', sortable: true },
  { key: 'read', value: 'read', title: 'Computados', sortable: true },
])

const headers = computed(() => items.value.length > 0 ? _headers.value : [])

// --- Footer ---
const footers = computed(() => [
  {
    type: 'Total',
    generated: items.value.reduce((acc, curr) => acc + curr.generated, 0),
    printed: items.value.reduce((acc, curr) => acc + curr.printed, 0),
    read: items.value.reduce((acc, curr) => acc + curr.read, 0),
  },
  {
    type: 'Valor Total',
    generated: currency(items.value.reduce((prev, curr) => prev + curr.generated * parseFloat(curr.price), 0)),
    printed: currency(items.value.reduce((prev, curr) => prev + curr.printed * parseFloat(curr.price), 0)),
    read: currency(items.value.reduce((prev, curr) => prev + curr.read * parseFloat(curr.price), 0)),
  },
])

</script>
